import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import actions from './actions'
import { Select } from 'loyal-react'

class SelectMobileOperator extends Component {
  constructor (props) {
    super(props)
    if (!this.props.operators || this.props.operators.length <= 0) {
      this.props.getMobileOperators()
    }
  }

  render () {
    let source = this.props.operators || []
    let value = source.find(item => item.description === this.props.description)
    return (
      <Select
        id={this.props.id}
        label={this.props.label}
        className={this.props.className}
        displayValue='description'
        selectedValue='mobileOperator'
        options={source}
        value={value}
        onChange={this.props.onChange}
        disabled={this.props.disabled}
      />
    )
  }
}
SelectMobileOperator.propTypes = {
  description: PropTypes.string,
  operators: PropTypes.array,
  onChange: PropTypes.func,
  getMobileOperators: PropTypes.func,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string
}

const mapStateToProps = ({ mobileOperators }) => {
  return { operators: mobileOperators }
}

const mapDispatchToProps = dispatch => ({
  getMobileOperators: () => {
    return dispatch(actions.getMobileOperators())
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectMobileOperator)



// WEBPACK FOOTER //
// ./src/features/SelectMobileOperator/SelectMobileOperator.js